import React, { useMemo, useState } from 'react'
import VirtualizedTable from './virtualisedTable'
import { Box, TableCell, TableRow } from '@mui/material'
import { withPercentWidths } from './mathHelper'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
const MuiltRenderTable = (props) => {
    const { idx = '', hideHeader = false, tableData = [], reportName = '', summaryFields = [], matches = [], currentIndex = 0, serialNokey = '',
        tableHeaderColor = {},
        cols = [],
        isInvoiceRedirect = false,
        showColumnBorders = false,
    } = props
    const sectionField = summaryFields.find((item) => item.isSection)
    const detailSummaryFields = summaryFields.filter((item) => !item.isSection)
    const leftSummaryFields = detailSummaryFields.filter((_, index) => index % 2 === 0)
    const rightSummaryFields = detailSummaryFields.filter((_, index) => index % 2 !== 0)
    const [sortConfig, setSortConfig] = useState({
        field: null,
        direction: null,
    });

    const filteredData = useMemo(() => {
        if (!sortConfig.field || !sortConfig.direction) return tableData;

        const { field, direction } = sortConfig;

        const isNumber = (v) => !isNaN(parseFloat(v)) && isFinite(v);

        const sortFn = (a, b) => {
            let valA = a[field];
            let valB = b[field];

            if (valA == null) valA = "";
            if (valB == null) valB = "";

            if (isNumber(valA) && isNumber(valB)) {
                valA = Number(valA);
                valB = Number(valB);
            } else {
                valA = String(valA).trim().toLowerCase();
                valB = String(valB).trim().toLowerCase();
            }

            if (valA < valB) return direction === "asc" ? -1 : 1;
            if (valA > valB) return direction === "asc" ? 1 : -1;
            return 0;
        };

        const result = [];
        let currentGroup = [];

        for (let i = 0; i < tableData.length; i++) {
            const item = tableData[i];

            if (item.dataType === 'subHeader' || item.dataType === 'header' || item.dataType === 'total') {
                // sort previous group before pushing new header
                if (currentGroup.length) {
                    const sortData = (currentGroup.sort(sortFn)).map((obj, index) => ({ ...obj, [serialNokey]: index + 1 }))
                    result.push(...sortData);
                    currentGroup = [];
                }

                result.push(item); // keep header in place
            } else {
                currentGroup.push(item);
            }
        }

        // sort last group
        if (currentGroup.length) {
            const sortData = (currentGroup.sort(sortFn)).map((obj, index) => ({ ...obj, [serialNokey]: index + 1 }))
            result.push(...sortData);
        }

        return result;
    }, [tableData, sortConfig]);
    const borderStyle = showColumnBorders ? '1px solid #d4dbe5' : 'none'
    const getColumnBorderStyles = (index, colSpan = 1) => {
        if (!showColumnBorders) return {}

        const isFirstColumn = index === 0
        const isLastColumn = index + colSpan >= cols.length

        return {
            borderLeft: isFirstColumn ? borderStyle : 'none',
            borderRight: isLastColumn ? borderStyle : borderStyle,
        }
    }
    const bodyContent = (cols, tableId) => (index, obj) => {
        return (
            <DisPatchBody
                row={obj}
                index={index}
                tableHeaderColor={tableHeaderColor}
                columnDefs={cols}
                matches={matches}
                currentIndex={currentIndex}
                tableId={tableId}
            />
        );
    };

    const DisPatchBody = ({ row, index, tableHeaderColor, columnDefs, matches, currentMatch, tableId }) => {
        if (!row?.dataType) return null

        const getStyles = (field, align, rowData, columnIndex, colSpan = 1) => {
            const common = {
                minHeight: '36px',
                fontSize: '12px',
                color: '#444',
                padding: '6px 8px',
                ...getColumnBorderStyles(columnIndex, colSpan),
            }

            if (row.dataType === 'header') {
                return {
                    ...common,
                    fontWeight: '700',
                    backgroundColor: tableHeaderColor?.isHeadingColor,
                    textAlign: align,
                }
            }

            if (row.dataType === 'entry') {
                return {
                    ...common,
                    fontWeight: '500',
                    textAlign: align || 'left',
                    height: '36px',
                    whiteSpace: 'pre-line',
                    borderRight: rowData?.borderRight || getColumnBorderStyles(columnIndex, colSpan).borderRight || 'none',
                }
            }

            if (row.dataType === 'subHeader') {
                return {
                    ...common,
                    fontWeight: '600',
                    backgroundColor: tableHeaderColor?.isSubHeadingColor,
                    textAlign: row.align?.[field] || 'left',
                    position: 'sticky',
                    borderRight: rowData?.borderRight || getColumnBorderStyles(columnIndex, colSpan).borderRight || 'none',
                }
            }

            if (row.dataType === 'total') {
                return {
                    ...common,
                    fontWeight: '600',
                    backgroundColor: tableHeaderColor?.isTotalColor,
                    textAlign: row.align?.[field] || 'right',
                    borderRight: rowData?.borderRight || getColumnBorderStyles(columnIndex, colSpan).borderRight || 'none',
                }
            }
        }

        return (
            <>
                {(() => {
                    let skip = 0
                    return columnDefs.map((item, i) => {
                        if (skip > 0) {
                            skip--
                            return null
                        }
                        const colSpan = row.colSpan?.[item.field] || 1
                        skip = colSpan - 1
                        const keyMatch = (field) => {
                            if (!matches) return false;
                            return Array.isArray(matches)
                                ? matches.some(m => m.tableId === tableId && m.rowIndex === index && m.field === field)
                                : false;
                        };
                        const isActive = (field) => {
                            if (!matches || matches.length === 0) return false;
                            const current = matches[currentIndex];
                            return current && current.tableId === tableId && current.rowIndex === index && current.field === field;
                        };
                        let checkSort = row.dataType === 'header' && item.isSortIcon && row.disableSortIcon !== true
                        return (
                            <TableCell
                                onClick={checkSort && handleSortClick(item.field)}
                                data-table={tableId}
                                data-row={index}
                                data-field={item.field}
                                className="reportTD"
                                key={item.field + i + index}
                                colSpan={colSpan}
                                style={getStyles(item.field, item.align, item.headerSx, i, colSpan)}
                            >
                                <span
                                    style={{
                                        backgroundColor: isActive(item.field)
                                            ? 'orange'
                                            : keyMatch(item.field)
                                                ? 'yellow'
                                                : 'transparent'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: item.align === 'right' ? 'end' : 'start' }}>
                                        {
                                            isInvoiceRedirect && (item.field === "BookingGSTInv" || item.field === "DelGSTInv") ? (
                                                row[item.field] ? (
                                                    <a
                                                        href={
                                                            item.field === "BookingGSTInv"
                                                                ? row?.BoookingGSTLink
                                                                : row?.DeliveryGSTLink
                                                        }
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ color: "blue", textDecoration: "underline" }}
                                                    >
                                                        {row[item.field]}
                                                    </a>
                                                ) : (
                                                    row[item.field]
                                                )
                                            ) : (
                                                row[item.field]
                                            )
                                        }
                                        {checkSort &&
                                            (
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        lineHeight: 0,
                                                    }}
                                                >
                                                    <ArrowDropUpIcon style={{ marginBottom: '-6px', color: sortConfig.field === item.field && sortConfig.direction === 'asc' ? '#fff' : '#444', width: 'auto !important' }} />
                                                    <ArrowDropDownIcon style={{ marginTop: '-6px', color: sortConfig.field === item.field && sortConfig.direction === 'desc' ? '#fff' : '#444', width: 'auto !important' }} />
                                                </div>
                                            )
                                        }
                                    </Box>
                                </span>
                            </TableCell>
                        )
                    })
                })()}
            </>
        )
    }
    const handleSortClick = (field) => () => {
        setSortConfig((prev) => {
            if (prev.field === field) {
                const newDirection = prev.direction === "asc" ? "desc" : "asc";
                return { field: field, direction: newDirection };
            } else {
                return { field: field, direction: "asc" };
            }
        });
    }
    const headerContent = (columns) => {
        let viewHeader = withPercentWidths(columns)

        return (
            <TableRow>
                {viewHeader.map((item) => {
                    return (
                        <TableCell
                            onClick={item.isSortIcon && handleSortClick(item.field)}

                            key={item.field}
                            style={{
                                backgroundColor: tableHeaderColor?.isHeadingColor,
                                color: '#444',
                                fontSize: '12px',
                                lineHeight: '16px',
                                letterSpacing: '0.24px',
                                fontWeight: '600',
                                whiteSpace: 'pre-line',
                                padding: '6px 8px',
                                width: item.width,
                                textAlign: item.align || 'left',
                                ...getColumnBorderStyles(viewHeader.findIndex((col) => col.field === item.field)),
                                borderRight: item.headerSx?.borderRight || getColumnBorderStyles(viewHeader.findIndex((col) => col.field === item.field)).borderRight || 'none',
                                verticalAlign: 'middle',
                                cursor: item.isSortIcon ? "pointer" : "default",
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: item.align === 'right' ? 'end' : 'start' }}>
                                {item?.header}
                                {item.isSortIcon && (
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            lineHeight: 0,
                                        }}
                                    >
                                        <ArrowDropUpIcon style={{ marginBottom: '-6px', color: sortConfig.field === item.field && sortConfig.direction === 'asc' ? '#fff' : '#444', width: 'auto !important' }} />
                                        <ArrowDropDownIcon style={{ marginTop: '-6px', color: sortConfig.field === item.field && sortConfig.direction === 'desc' ? '#fff' : '#444', width: 'auto !important' }} />
                                    </div>
                                )}
                            </Box>
                        </TableCell>
                    )
                })}
            </TableRow>
        )
    }
    return (
        <Box data-table={idx} key={idx} style={{ marginBottom: '20px', padding: '0px 10px' }}>
            {!!reportName && <Box sx={{ fontWeight: '600', padding: '10px 0px' }}>{reportName}</Box>}
            {!!summaryFields.length && (
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                        gap: '4px 24px',
                        marginBottom: '10px',
                        fontSize: '12px',
                        color: '#444',
                        fontWeight: '600',
                    }}
                >
                    {sectionField && (
                        <Box sx={{ gridColumn: '1 / -1', paddingBottom: '4px' }}>
                            {sectionField.value}
                        </Box>
                    )}
                    <Box>
                        {leftSummaryFields.map((item) => (
                            <Box key={`${reportName}-${item.label}`} sx={{ paddingBottom: '4px' }}>
                                {item.label} : {item.value}
                            </Box>
                        ))}
                    </Box>
                    <Box>
                        {rightSummaryFields.map((item) => (
                            <Box key={`${reportName}-${item.label}`} sx={{ paddingBottom: '4px', textAlign: { xs: 'left', md: 'right' } }}>
                                {item.label} : {item.value}
                            </Box>
                        ))}
                    </Box>
                </Box>
            )}
            <VirtualizedTable
                id={idx}
                tableData={filteredData}
                headerContent={hideHeader ? false : () => headerContent(cols)}
                rowContent={bodyContent(cols, idx)}
                // tableStyle={{ tableLayout: 'auto', width: '100%' }}
                autoResize={true}
                matches={matches}
                currentIndex={currentIndex}
                serialNokey={serialNokey}
                isWindowScroll={true}
            />
        </Box>
    )
}

export default MuiltRenderTable